import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import { useTranslation } from "react-i18next";

import AuthUser from "../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../components/Spinner";

const CertificadoFilter = ({ onFilterSubmit, cursos }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao } = AuthUser();

  const [nomeFilter, setNomeFilter] = useState("");
  const [siglaFilter, setSiglaFilter] = useState("");

  const [itemFocus, setItemFocus] = useState(false);
  const [cursoID, setCursoID] = useState("-1");

  const [data1, setData1] = useState("1900-12-31");
  const [data2, setData2] = useState("2099-12-31");

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [certificados, setCertificados] = useState([]);

  const inputFocus = () => {
    setItemFocus(true);
  };

  const inputBlur = () => {
    setItemFocus(false);
  };

  const handleSubmitFilterCertificados = async () => {
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("formando_id", "-1");
      formData.append("data1", data1);
      formData.append("data2", data2);
      formData.append("estado", "-1");
      formData.append("curso_id", cursoID);

      const res = await http.post("/filtrar-certificados", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const certificados = res?.data?.certificados || [];
      setCertificados(certificados);

      onFilterSubmit(certificados);
    } catch (error) {
      console.error(error);
      //notifyError("Error searching certificates.");
    } finally {
      setLoading(false);
    }
  };

   const renderOptionCursos = (cursos) => {
      return cursos?.map((curso) => (
        <React.Fragment key={curso.id}>
          <option value={curso.id}>{curso.sigla+" - "+curso.designacao}</option>
        </React.Fragment>
      ));
    };

  return (
    <div className="row filter-row space">
      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="text"
            name="nameFilter"
            className="form-control floating"
            onFocus={inputFocus}
            onBlur={inputBlur}
            value={nomeFilter}
            onChange={(e) => setNomeFilter(e.target.value)}
          />
          <label className="focus-label">{t("Name")}</label>
        </div>
      </div>
      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="date"
            name="nameFilter"
            className="form-control floating"
            value={data1}
            onChange={(e) => setData1(e.target.value)}
          />
          <label className="focus-label">{t("Data1")}</label>
        </div>
      </div>
      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="date"
            name="nameFilter"
            className="form-control floating"
            value={data2}
            onChange={(e) => setData2(e.target.value)}
          />
          <label className="focus-label">{t("Data2")}</label>
        </div>
      </div>
      
      <div className="col-sm-12 col-md-4">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <select
            className="form-control select"

            onChange={(e) => setCursoID(e.target.value)}
          >
            <option value={-1}>Escolha a certificação</option>
            {renderOptionCursos(cursos)}
          </select>
          <label className="focus-label">{t("Certificação")}</label>
        </div>
      </div>

      <div className="col-sm-12 col-md-2">
        <span
          className="btn btn-success btn-block w-100"
          onClick={() => handleSubmitFilterCertificados()}
        >
          {loading ? <i className="fa fa-spinner fa-spin me-2"></i>:t("Search")}
        </span>
      </div>

      <ToastContainer />
    </div>
  );
};

export default CertificadoFilter;
